export default __webpack_public_path__ + "calendar.e2fd8c5aa194e9ee.svg";